module.exports = __webpack_public_path__ + "img/arrow-left.e0f2b53f.svg";